import { api } from '@/core/lib/api'
import type { TResponse } from '@/core/types/axios'

import { authEndpoints } from './auth.constants'
import type {
  TAuthRole,
  TAuthUser,
  TForgotPasswordRequest,
  TResetPasswordRequest,
  TSignInRequest,
  TTokens,
} from './auth.types'

export async function signInRequest(body: TSignInRequest): Promise<TTokens> {
  const res = await api.post<TResponse<TTokens>>(authEndpoints.signIn, body)
  return res.data.data
}

export async function forgotPasswordRequest(
  body: TForgotPasswordRequest
): Promise<void> {
  await api.put(authEndpoints.forgotPassword, body)
}

export async function resetPasswordRequest(
  body: TResetPasswordRequest
): Promise<void> {
  await api.put(authEndpoints.resetPassword, body)
}

// Backend `/auth/me` ham izin/rol şekli. `roles` bugün düz string dizisi döner;
// backend zenginleştirmesinden (sonraki adım) sonra izinleriyle nesne dönecek.
// İstemci her iki şekli de normalize eder.
type TPermissionRaw = {
  id: string
  key: string
  description?: string | null
}

type TAuthRoleRaw = {
  id: string
  name: string
  description?: string | null
  permissions?: TPermissionRaw[]
}

type TMeRaw = {
  id: string
  email: string
  name: string
  is_active: boolean
  roles: Array<string | TAuthRoleRaw>
  permissions: string[]
  created_at?: string
  updated_at?: string
}

function toAuthRole(raw: string | TAuthRoleRaw): TAuthRole {
  if (typeof raw === 'string') {
    return { id: raw, name: raw, description: null, permissions: [] }
  }
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description ?? null,
    permissions: (raw.permissions ?? []).map((p) => ({
      id: p.id,
      key: p.key,
      description: p.description ?? null,
    })),
  }
}

export async function fetchMe(): Promise<TAuthUser> {
  const res = await api.get<TResponse<TMeRaw>>(authEndpoints.me)
  const raw = res.data.data
  return {
    id: raw.id,
    email: raw.email,
    name: raw.name,
    is_active: raw.is_active,
    roles: raw.roles.map(toAuthRole),
    permissions: raw.permissions,
    created_at: raw.created_at,
    updated_at: raw.updated_at,
  }
}
